import { BaseEdge, type Edge, type EdgeProps } from "@xyflow/react";
import {
  type RuleGraphEdgeFill,
  RuleGraphEdgeFillPath,
} from "./RuleGraphEdgeFillPath";

export const RuleGraphRoutedEdge = ({
  id,
  data,
  markerEnd,
  style,
}: EdgeProps<Edge<{ path: string; fill?: RuleGraphEdgeFill }>>) => (
  <>
    <BaseEdge
      id={id}
      path={data?.path ?? ""}
      markerEnd={markerEnd}
      style={style}
    />
    {data?.fill ? (
      <RuleGraphEdgeFillPath path={data.path} fill={data.fill} />
    ) : null}
  </>
);
